import React from 'react';
import { ClassNameFormatter, cn } from '@bem-react/classname';
import { AppButton, AppModal } from '@frontend-modules/ui-kit';

interface TaskDeleteModalProps {
    isOpen: boolean;
    handleCloseDeleteModal: () => void;
    handleDeleteSubmit: () => void;
}
const CnTaskDeleteModal = cn('task-delete-modal');

import './TaskDeleteModal.style.scss';
export const TaskDeleteModal: React.FC<TaskDeleteModalProps> = (props) => {
    const { isOpen, handleCloseDeleteModal, handleDeleteSubmit } = props;

    if (!isOpen) return null;

    return (
        <AppModal
            width={320}
            isShow={isOpen}
            onCancel={handleCloseDeleteModal}
            setShow={() => null}
            className={CnTaskDeleteModal()}
            isShowCloseIcon={false}
            title={'Вы действительно хотите удалить задание?'}
        >
            <div className={CnTaskDeleteModal('buttons')}>
                <AppButton label={'Удалить'} onClick={handleDeleteSubmit} type={'primary'} />
                <AppButton label={'Отмена'} onClick={handleCloseDeleteModal} type={'outline'} />
            </div>
        </AppModal>
    );
};
